import { Badge } from "flowbite-react"

const Status = ({ status }) => {
  const getColor = () => {
    switch (status) {
      case 'initial_outreach':
        return 'indigo';

      case 'negotiating':
        return 'indigo';

      case 'finalizing':
        return 'purple';

      case 'declined':
        return 'failure';

      case 'escalated':
        return 'success';

      default:
        return 'gray';
    }
  }

  const getLabel = () => {
    switch (status) {
      case 'initial_outreach':
        return 'Initial Outreach';

      case 'negotiating':
        return 'Negotiating';

      case 'finalizing':
        return 'Finalizing';

      case 'declined':
        return 'Declined';

      case 'escalated':
        return 'Escalated';

      default:
        return status;
    }
  }

  return <Badge color={getColor()}>{getLabel()}</Badge>;
}

export default Status;